module.exports = __webpack_public_path__ + "static/img/smqnewm.f58d396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smqnewm.png
// module id = tJyS
// module chunks = 1